import { render } from "./DeliveryGroupEdit.vue?vue&type=template&id=44382230"
import script from "./DeliveryGroupEdit.vue?vue&type=script&lang=js"
export * from "./DeliveryGroupEdit.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__